/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FXParticle } from './FXParticle';

export class FXParticlePool {
  private static instance: FXParticlePool;

  private readonly freeParticles: FXParticle[];

  public static getInstance(): FXParticlePool {
    if (!this.instance) this.instance = new FXParticlePool();
    return this.instance;
  }

  constructor() {
    this.freeParticles = [];
  }

  public getParticle(): FXParticle {
    if (this.freeParticles.length > 0) return this.freeParticles.pop()!;
    return new FXParticle();
  }

  public addParticle(particle: FXParticle): void {
    this.freeParticles.push(particle);
  }

  public fillParticlePool(count: number): void {
    const currentCount = this.freeParticles.length;
    const toFill = Math.max(count - currentCount, 0);
    for (let i = 0; i < toFill; i += 1) {
      this.addParticle(new FXParticle());
    }
  }

  public clear(): void {
    for (let i = 0; i < this.freeParticles.length; i += 1) {
      this.freeParticles[i].destroy();
    }
    this.freeParticles.length = 0;
  }
}
